var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "104px",
    viewBox: "0 0 117 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Page/Message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Message-\\u2709\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messages---Empty",
    transform: "translate(-131.000000, -222.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Page/Message",
    transform: "translate(74.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.363636,49.5 L136.772727,49.5 L136.772727,33.6 C136.772727,27.77 131.986364,23 126.136364,23 L67.6363636,23 C61.7863636,23 57,27.77 57,33.6 L57,72.82 C57,78.65 61.7863636,83.42 67.6363636,83.42 L75.0818182,83.42 L75.0818182,95.61 C75.0818182,98.79 77.2090909,100.91 80.4,100.91 C81.4636364,100.91 82.5272727,100.38 83.5909091,99.85 L94.2272727,91.9 L94.2272727,98.79 C94.2272727,104.62 99.0136364,109.39 104.863636,109.39 L124.540909,109.39 L147.940909,125.82 C149.004545,126.35 150.068182,126.88 151.131818,126.88 C154.322727,126.88 156.45,124.76 156.45,121.58 L156.45,109.39 L163.363636,109.39 C169.213636,109.39 174,104.62 174,98.79 L174,60.1 C174,54.27 169.213636,49.5 163.363636,49.5 Z M80.4,95.61 L80.4,78.12 L67.6363636,78.12 C64.4454545,78.12 62.3181818,76 62.3181818,72.82 L62.3181818,33.6 C62.3181818,30.42 64.4454545,28.3 67.6363636,28.3 L126.136364,28.3 C129.327273,28.3 131.454545,30.42 131.454545,33.6 L131.454545,72.29 C131.454545,75.47 129.327273,77.59 126.136364,77.59 L104.863636,77.59 L102.736364,79.18 L80.4,95.61 Z M168.681818,99.32 C168.681818,102.5 166.554545,104.62 163.363636,104.62 L150.6,104.62 L150.6,122.11 L126.136364,104.62 L104.863636,104.62 C101.672727,104.62 99.5454545,102.5 99.5454545,99.32 L99.5454545,88.19 L106.459091,83.42 L126.136364,83.42 C131.986364,83.42 136.772727,78.65 136.772727,72.82 L136.772727,54.8 L163.363636,54.8 C166.554545,54.8 168.681818,56.92 168.681818,60.1 L168.681818,99.32 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 80,
    cy: 54,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 96,
    cy: 54,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 134,
    cy: 81,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 111,
    cy: 54,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 149,
    cy: 81,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2153eabb7c3e7c23b61177e164b8152c.svg";
export { ForwardRef as ReactComponent };